export const JOB_TYPE_LOAD_REQUEST = "JOB_TYPE_LOAD_REQUEST";
export const JOB_TYPE_LOAD_SUCCESS = "JOB_TYPE_LOAD_SUCCESS";
export const JOB_TYPE_LOAD_FAIL = "JOB_TYPE_LOAD_FAIL";
export const JOB_TYPE_LOAD_RESET = "JOB_TYPE_LOAD_RESET";